import React from 'react';
import { Image, View } from 'react-native-web';
import { getImageByKey, img_sprites } from '../../../../utils/ImagesManagementUtils';
import {
  Android,
  keyboard_logo,
  onboarding_big_stickers,
  onboarding_small_stickers,
} from '../../../../utils/DictionaryManagementUtils';
import ChatBubbles from '../../AuxiliaryComponent/Images/ChatBubbles';
import FullPageSpecialSimulator from '../FullPageSpecialSimulator';
import PhoneFrame from '../../AuxiliaryComponent/Images/PhoneFrame';

const SplashScreenStickersFP = ({
  globJSON,
  simPlatform,
  imageSource,
  LabelInputText,
  TopTitle,
  withStatusBar,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { promotion } = globJSON.configurations.onboarding;
  const img_stub = getImageByKey(globJSON.configurations.services.menu.keyboard_logo, keyboard_logo);

  const stickers_b = getImageByKey(promotion.onboarding_big_stickers, onboarding_big_stickers);
  const stickers_s = getImageByKey(promotion.onboarding_small_stickers, onboarding_small_stickers);

  const myStyles = {
    phoneImage: {
      width: 240,
      height: simPlatform === Android ? 427 : 520,
    },
    borderSep: {
      width: 182,
      height: 26,
      alignSelf: 'center',
      marginTop: 20,
      justifyContent: 'center',
      zIndex: 1,
      backgroundColor: colors.light_elements_color,
      marginBottom: simPlatform !== Android && 15,
    },
    spritesCircleContainer: {
      width: 20,
      height: 20,
      borderRadius: 10,
      backgroundColor: '#fff',
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.22,
      shadowRadius: 12,
    },
    spritesCircle: {
      width: 20,
      height: 20,
    },
    spritesBox: {
      width: 184,
      height: 104,
      alignSelf: 'center',
      marginTop: simPlatform === Android ? 90 : 120,
      position: 'absolute',
    },
    stickersBigBox: {
      width: 177,
      height: 50,
      alignSelf: 'center',
      marginBottom: 16,
    },
    stickersSmallBox: {
      width: 150,
      height: 15,
      alignSelf: 'center',
    },
    bubblesContainer: {
      alignSelf: 'center',
      marginTop: simPlatform === Android ? 5 : 10,
    },
  };
  return (
    <FullPageSpecialSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      WithImageBackground={imageSource}
      TopTitle={TopTitle}
      LabelInputText={LabelInputText}
      numOfPointThatGetColor={4}
      withStatusBar={withStatusBar}
    >
      <View>
        <View style={myStyles.bubblesContainer}>
          <ChatBubbles
            simPlatform={simPlatform}
            backgroundColor={colors.app_background_color}
            ToptintColor={colors.disabled_cta_color}
            BottomtintColor={colors.primary_cta_color}
          />
        </View>
        <View style={myStyles.borderSep}>
          <View style={myStyles.spritesCircleContainer}>
            <Image
              fadeDuration={0}
              resizeMode="stretch"
              style={myStyles.spritesCircle}
              source={img_stub}
            />
          </View>
        </View>
        <Image
          fadeDuration={0}
          style={myStyles.stickersBigBox}
          source={stickers_b}
        />
        <Image
          fadeDuration={0}
          style={myStyles.spritesBox}
          source={img_sprites}
        />
        <Image
          fadeDuration={0}
          style={myStyles.stickersSmallBox}
          source={stickers_s}
        />
      </View>
      {simPlatform !== Android && withStatusBar && (<PhoneFrame />)}
    </FullPageSpecialSimulator>

  );
};

export default SplashScreenStickersFP;
